import { EXPERIMENT_VARIATION, NEW_CSW } from 'shared/experiments/consts'
import Experiment from 'views/components/utils/optimizely/Experiment'
import CrosssellSliderAlternative from 'views/containers/crosssell/CrosssellSliderTop'

// Separate module needed to allow the router serve it
// @see app/server/utils/loadModules.js
import CrosssellSlider from './CrosssellSlider'

const SliderProxy = props => {
  const { className, sparse, ...cleanProps } = props

  return (
    <Experiment name={NEW_CSW} classNames="e-newCsw">
      {exp => {
        return [EXPERIMENT_VARIATION.V1, EXPERIMENT_VARIATION.V2].includes(
          exp.variant
        ) ? (
          <CrosssellSliderAlternative {...props} />
        ) : (
          <CrosssellSlider {...cleanProps} />
        )
      }}
    </Experiment>
  )
}

SliderProxy.propTypes = CrosssellSlider.propTypes
SliderProxy.defaultProps = CrosssellSlider.defaultProps

export default SliderProxy
